import { useLocation } from 'react-router-dom';
import { pageRoutes } from 'shared/routes';
import { useTitleStoreTitle } from 'shared/lib/store';
import { isImpersonate } from 'shared/lib/api';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { usePageTitle } from 'shared/lib/title';
import {
  useLogout,
  useGetUser,
  type AuthenticatedContractorModel,
  type AuthenticatedManagerModel,
} from 'entities/profile';
import { HEAD_LAYOUT_ID } from 'entities/faq';

import { useInjectToGrowthBook } from './useInjectToGrowthBook';

const titles: Record<string, string> = {
  contractors: 'Contractors',
  campaigns: 'Campaigns',
  leads: 'Leads',
  appointments: 'Appointments',
  invoices: 'Invoices',
  billing: 'Billing',
  myAccount: 'My account',
  groups: 'Groups',
  overlapping: 'Overlapping',
  sales: 'Sales',
  faq: 'FAQs',
  reports: 'Reports',
  reportsOverview: 'Reports',
  reportsPerformance: 'Reports',
  reportsCampaignMap: 'Reports',
  reportsVerticalBenchmark: 'Reports',
};

const getHeader = (pathname: string) => {
  const path = pathname;
  const appRoutesEntry = Object.entries(pageRoutes).map(([, routeEntry]) => routeEntry);
  const matchedRouteEntry =
    appRoutesEntry.find((routeEntry) =>
      Object.values(routeEntry).find((routePath) => routePath.split(':')[0] === path)
    ) || {};

  const entries: [string, string][] = Object.entries(matchedRouteEntry);
  const routeNode = entries.find(([, routePath]) => routePath.split(':')[0] === path) || [''];

  return titles[routeNode[0]];
};

export function LayoutHeader() {
  const person = useGetUser<AuthenticatedManagerModel | AuthenticatedContractorModel>().data?.data;

  // TODO this is a temporary solution and must be removed ASAP!
  useInjectToGrowthBook(person);

  const location = useLocation();
  const title = useTitleStoreTitle();
  const page = title || getHeader(location.pathname);
  const logout = useLogout();
  const onLogoutClick = () => {
    const action = isImpersonate() ? window.close : () => logout();

    action();
  };

  usePageTitle(getHeader(location.pathname));

  return (
    <div
      className="align-center z-20 flex h-16 items-center justify-between border-b border-slate-100 bg-white px-8"
      id={HEAD_LAYOUT_ID}
    >
      <div className="text-lg font-medium">{page}</div>
      {person && (
        <div className="flex flex-col font-medium">
          <div className="text-xs">{'companyName' in person ? person.companyName : person.fullName}</div>
          <div
            className="cursor-pointer select-none text-right text-xs text-deep-blue-500"
            onClick={onLogoutClick}
            {...getDataAutoTestAttributes(['button-logout']).attributes}
          >
            Logout
          </div>
        </div>
      )}
    </div>
  );
}
